<script>
  import { onDestroy } from "svelte";
  import { eventBus } from "../lib/eventBus";
  import { destroySvelteComponentInstance, mountFederatedSvelteComponent } from "../lib/mountFederatedSvelteComponent";
  import OpportunitiesTable from "../components/opportunitiesTable.svelte";
  import OpportunityPopupEditor from "../components/opportunityPopupEditor.svelte";
  import OpportunityOptions from "../components/opportunityOptions.svelte";
  import SyncButtons from "../components/syncButtons.svelte";
  import PageContainer from "../components/shared/PageContainer.svelte";

  export const location = undefined;
  export const navigate = undefined;

  let el1;
  let refreshKey = 0;
  let opportunitiesCountInstance = null;

  const mountOpportunityCount = async () => {
    const module = await import("App/alaceOpportunities/count");
    const OpportunitiesCount = module.default;
    if (el1) {
      opportunitiesCountInstance = mountFederatedSvelteComponent(
        opportunitiesCountInstance,
        OpportunitiesCount,
        { target: el1 }
      );
    }
  };

  void mountOpportunityCount();

  const handleRefreshOpportunities = () => {
    mountOpportunityCount();
    refreshKey += 1;
  };

  eventBus.on("refresh-opportunities", handleRefreshOpportunities);
  window.addEventListener("refresh-opportunities", handleRefreshOpportunities);

  onDestroy(() => {
    opportunitiesCountInstance = destroySvelteComponentInstance(opportunitiesCountInstance);
    window.removeEventListener("refresh-opportunities", handleRefreshOpportunities);
  });
</script>

<PageContainer fullWidth={true} className="px-4 py-5 sm:px-6 lg:px-8">
  <div class="grid grid-cols-1 gap-3 w-full">
    <div class="uimodule" bind:this={el1} />
    <div class="uimodule">
      <OpportunityPopupEditor />
    </div>
    <div class="uimodule">
      <SyncButtons />
    </div>
    {#key refreshKey}
      <div class="uimodule">
        <OpportunitiesTable />
      </div>
    {/key}
    <div class="uimodule">
      <OpportunityOptions />
    </div>
  </div>
</PageContainer>
